import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import $ from 'jquery';

let cntrlIsPressed = false;
let timer = 0;
const delay = 200;
let prevent = false;

class tt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: "first",
      second: "second",
    };

    this.handleClick = this.handleClick.bind(this);
    this.contextmenu = this.contextmenu.bind(this);
    this.double = this.double.bind(this);
    this.doClickAction = this.doClickAction.bind(this);
    this.doDoubleClickAction = this.doDoubleClickAction.bind(this);
  }

  componentDidMount() {
    const mouseschroll = () => {
      $(document).keydown((event) => {
        if (event.which == "17") {
          cntrlIsPressed = true;
        }
      });
      $(document).keyup(() => {
        cntrlIsPressed = false;
      });
    };
    mouseschroll();
  }

  doClickAction(event, value) {
    console.log('value: ', value);
    if (cntrlIsPressed) {
      if (value == 1) {
        this.setState({
          first: "third",
        });
      } else {
        this.setState({
          second: "third",
        });
      }
    }
  }

  handleClick(event, value) {
    console.log("dsf");
    timer = setTimeout(() => {
      if (!prevent) {
        this.doClickAction(event, value);
      }
      prevent = false;
    }, delay);
  }

  double(value) {
    console.log("here");
    clearTimeout(timer);
    prevent = true;
    this.doDoubleClickAction(value);
  }

  doDoubleClickAction(value) {
    console.log('value: ', value);
  }

  contextmenu() {
    console.log("there");
  }

  render() {
    return (
      <div className="">
         <div id={1} onContextMenu={this.contextmenu} onDoubleClick={() => this.double(1)} onClick={(e) => this.handleClick(e, 1)}>
          {this.state.first}
         </div>
         <div id={2} onClick={(e) => this.handleClick(e, 2)}>
            {this.state.second}
         </div>
      </div>
    );
  }
}

tt.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

export default connect(mapStateToProps)(withSnackbar(tt));
